'use strict';

var selectedField = '_selected';

var MultiSelectDropDownList = window.kendo.ui.DropDownList.extend({
    init: function (element, options) {
        var self = this;

        options.template = kendo.template(
            kendo.format('<label><input type="checkbox" # if({3}){# checked="checked" #}#  name="{0}" value="#= {1} #" />#= {2} #</label>',
                element.id + '_option_' + options.dataValueField,
                options.dataValueField,
                options.dataTextField,
                selectedField
            )
        );

        window.kendo.ui.DropDownList.fn.init.call(self, element, options);

        // SAGGRC-613: Scrollen der Liste muss f�r das DropDown �berschrieben werden
        // Knockout scrollt beim Aktualisieren der Daten immer zum letzt angew�hlten Eintrag
        // Dies wird hiermit unterbunden
        self.listView.scroll = function() {};
    },

    options: (function () {
        return {
            name: 'MultiSelectDropDownList'
        };
    })(),

    _listOptions: function(options) {
        var baseOptions = window.kendo.ui.DropDownList.fn._listOptions.call(this, options);

        baseOptions.selectable = 'multiple';

        return baseOptions;
    },

    selectedIndexes: [],

    _accessor: function (vals, idx) {
        var self = this;

        if (vals === undefined) {
            return self.selectedIndexes;
        }
    },

    value: function (vals) {
        var self = this;

        if (vals === undefined) {
            return self._accessor();
        } else {
            var checkboxes = self.ul.find("input[type='checkbox']");
            var valArray = vals.map(function (item) {
                return item + '';
            });

            checkboxes.each(function () {
                this.checked = $.inArray(this.value, valArray) !== -1;
            });

            self._setValues();
        }

        return window.kendo.ui.DropDownList.fn.value.call(self, vals);
    },

    _select: function () {
        var self = this;
        return $.Deferred(function () {
            var that = this;
            var values = self.ul.find(":checked").map(function () { return this.value; }).toArray();
            var added = null;
            var removed = null;

            for (var i = 0; i < values.length; i++) {
                if (self.selectedIndexes.indexOf(values[i]) === -1) {
                    added = values[i];
                    break;
                }
            }

            for (var j = 0; j < self.selectedIndexes.length; j++) {
                if (values.indexOf(self.selectedIndexes[j]) === -1) {
                    removed = self.selectedIndexes[j];
                    break;
                }
            }

            if (values < self.selectedIndexes || values > self.selectedIndexes) {
                self._setValues();

                self.trigger('change', {
                    added: added,
                    removed: removed
                });
            }
            that.resolve();
        }
        );
    },

    _blur: function () { },
        
    _setValues: function () {
        var self = this;

        var values = self.ul.find(":checked").map(function () {
            return this.value;
        }).toArray();

        self.selectedIndexes = values;
        self.element.val(values);
    },
    _textAccessor: function(text) {
        var span = this.span;
        if (text === undefined)
            return span.text();
        else {
            var selectedTexts = this.ul.find(":checked").map(function () { return $(this).parent().text(); }).toArray();

            if (selectedTexts.length === 0) {
                span.text('');
            } else {
                span.text(selectedTexts.join('; '));
            }
        }
    }
});

kendo.ui.plugin(MultiSelectDropDownList);

ko.kendo.bindingFactory.createBinding({
    name: 'kendoMultiSelectDropDownList',
    events: {
        change: 'value',
        open: {
            writeTo: 'isOpen',
            value: true
        },
        close: {
            writeTo: 'isOpen',
            value: false
        }
    },
    watch: {
        enabled: 'enable',
        isOpen: ['open', 'close'],
        data: function (value) {
            var self = this;
            if (value) {
                var allValues = self.value();
                value.forEach(function (v) {
                    v[selectedField] = allValues.indexOf(v[self.options.dataValueField]) > -1;
                });
            }
            ko.kendo.setDataSource(self, value);
        },
        values: function (value) {
            this.value(value);
        }
    }
});

export default MultiSelectDropDownList;